<template>
  <div class="header-row">
    <div v-if="!isSubscribed" class="header-left">
      <ib-button
        variant="black"
        outline
        size="sm"
        font-family="medium"
        submit-button
        @click="onClickBackBtn"
      >
        {{ $t('back') }}
      </ib-button>
    </div>

    <div class="header-center">
      <subscription-alert
        v-if="subscriptionIsFreeTrialExpired"
        rounded-mode="always"
        :text="`${$t('pages.billing.yourFreeTrialHasExpired')}`"
      />
    </div>

    <!--    <div class="header-right">-->
    <!--      <img class="ideabuddy-logo" src="@/assets/img/logos/ideaBuddy-color.svg" width="130" alt="logo">-->
    <!--    </div>-->
  </div>
</template>

<script>
import SubscriptionAlert from '@/views/Payment/Components/SubscriptionAlert.vue'
import UserSubscriptionMixin from '@/mixins/permissions/userSubscription'
import { mapGetters } from 'vuex'

export default {
  name: 'BillingHeader',

  components: { SubscriptionAlert },

  mixins: [UserSubscriptionMixin],

  computed: {
    ...mapGetters('user', ['isSubscribed']),
    ...mapGetters('ideaCollection', ['getSharedIdeasCount'])
  },

  methods: {
    onClickBackBtn () {
      if (this.isSubscribed || this.getSharedIdeasCount) {
        this.$router.push({ name: 'home' })

        return
      }

      this.logout()
    },

    logout () {
      this.$cookies.remove('access_token')
      localStorage.removeItem('persisted_state')
      this.$intercom.shutdown()
      this.$store.dispatch('resetState')
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style scoped lang="scss">
.header-row {
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 12px;

  .header-left,
  .header-right {
    display: none;
  }

  .header-center {
    justify-self: center;
  }

  @include media-breakpoint-up($md) {
    grid-template-columns: auto 1fr auto;

    .header-left,
    .header-right {
      display: block;
    }

    .header-left {
      justify-self: start;
    }

    .header-center {
      justify-self: center;
    }

    .header-right {
      width: 1px;
    }
  }
}

.ideabuddy-logo {
  height: 100%;
  padding: 0.625rem 0;
  width: 130px;
}
</style>
